import { Link } from 'react-router-dom';

export default function ServicesHero() {
  return (
    <section
      className="relative w-full min-h-screen flex items-center overflow-hidden"
      style={{
        backgroundImage:
          'url(https://public.readdy.ai/ai/img_res/7ca0d2c8e0f556087c6f8846616ad6c0.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center 40%',
      }}
    >
      {/* Cinematic overlays */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A]/96 via-[#0A0A0A]/80 to-[#0A0A0A]/30" />
      <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/60 via-transparent to-[#0A0A0A]/70" />

      {/* Vertical accent */}
      <div className="absolute left-0 top-0 h-full w-0.5 bg-gradient-to-b from-transparent via-[#C9A030]/40 to-transparent hidden lg:block" />

      {/* Top breadcrumb bar */}
      <div className="absolute top-0 left-0 w-full pt-24 px-6 lg:px-14 z-10">
        <p className="text-[#C9A030] text-[10px] tracking-[0.4em] uppercase font-semibold flex items-center gap-3">
          <Link to="/" className="hover:text-[#D4B045] cursor-pointer transition-colors">Home</Link>
          <span className="text-[#F2EDE3]/20">/</span>
          <span className="text-[#F2EDE3]/50">Services</span>
        </p>
      </div>

      {/* Main content */}
      <div className="relative z-10 w-full px-6 lg:px-14 pb-20">
        <div className="max-w-[700px]">
          <div className="flex items-center gap-4 mb-8">
            <div className="w-10 h-px bg-[#C9A030]" />
            <p className="text-[#C9A030] text-[10px] tracking-[0.45em] uppercase font-semibold">
              Six Compliance Solutions
            </p>
          </div>

          <h1 className="font-serif leading-[1.05] tracking-tight mb-8">
            <span className="block text-[48px] lg:text-[76px] font-light text-[#F2EDE3]">
              Expert Compliance
            </span>
            <span className="block text-[48px] lg:text-[76px] font-light text-[#F2EDE3]">
              Services for
            </span>
            <span className="block text-[48px] lg:text-[76px] font-light text-[#C9A030] italic">
              Energy Contractors
            </span>
          </h1>

          <p className="text-[#F2EDE3]/50 text-lg font-light leading-relaxed mb-9 max-w-[520px]">
            ISNetworld®, Veriforce, Avetta, RAVS Plus, Safety Training, and Injury Rate Reduction — all handled by the same dedicated specialist with guaranteed results.
          </p>

          <div className="flex flex-wrap gap-3 mb-12">
            <a
              href="tel:4054081117"
              className="inline-flex items-center gap-2.5 bg-[#C9A030] text-[#0A0A0A] px-8 py-4 text-[11px] font-bold tracking-[0.22em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200 hover:bg-[#D4B045]"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-phone-fill text-xs" />
              </span>
              Call 405-408-1117
            </a>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 border border-[#F2EDE3]/22 text-[#F2EDE3]/70 px-8 py-4 text-[11px] font-medium tracking-[0.22em] uppercase whitespace-nowrap cursor-pointer transition-colors duration-200 hover:border-[#C9A030]/60 hover:text-[#C9A030]"
            >
              Get a Compliance Review
            </Link>
          </div>

          {/* Services quick list */}
          <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
            {['ISNetworld®', 'Veriforce', 'Avetta', 'RAVS Plus', 'Safety Training', 'Injury Rate Reduction'].map((s) => (
              <div key={s} className="flex items-center gap-2">
                <div className="w-3.5 h-3.5 flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-[#C9A030] text-xs" />
                </div>
                <span className="text-[#F2EDE3]/55 text-xs font-light tracking-wide">{s}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll cue */}
      <div className="absolute bottom-8 left-14 hidden lg:flex flex-col items-center gap-3 text-[#F2EDE3]/20">
        <div className="w-px h-14 bg-gradient-to-b from-[#C9A030]/50 to-transparent" />
        <span className="text-[9px] tracking-[0.4em] uppercase font-light">Scroll</span>
      </div>
    </section>
  );
}
